<div *ngIf="currentState !== State.EDIT_STATUS_SETTINGS">
  <div *ngIf="currentState === State.SELECT_ABSENCE_STATUS">
    <div *ngIf="activeStatusModel" class="status-container">
      <div class="icon-container">
        <img height="60" alt="tick" [src]="activeStatusModel.img" />
      </div>
      <div>
        <button
          id="currentStatus"
          class="currentStatus"
          *ngIf="activeStatusModel.reasonId !== 0"
          mat-button
          (click)="changeState(State.CHANGE_DURATION)"
          [disabled]="activeStatusModel && (activeStatusModel.reasonId === 100 || activeStatusModel.reasonId === 101)"
        >
          {{ activeStatusModel.message }} {{ activeStatusAsAbsentModel.endTime ? ('global.until' | translate) : '' }}
          <ng-container *ngIf="activeStatusAsAbsentModel.endTime">
            {{ activeStatusAsAbsentModel.endTime | timeAndDateFormatter }}
          </ng-container>
        </button>
        <button class="currentStatus" *ngIf="activeStatusModel.reasonId === 0" [disabled]="true" mat-button>
          {{ activeStatusModel.message }}
        </button>
        <button class="currentStatusAppointmentSubject" *ngIf="activeStatusAsAbsentModel.appointmentSubject" [disabled]="true" mat-button>
          {{ activeStatusAsAbsentModel.appointmentSubject }}
        </button>
        <button id="settingsButton" class="currentStatusSubheader" mat-button (click)="changeState(State.EDIT_STATUS_SETTINGS)">
          {{ activeStatusModel.getForwardingText() | translate }} {{ activeStatusModel.forwardingNumber | phoneNumberFormatter }}
          {{ activeStatusModel.getForwardingDelay() | forwardingDelay }}
        </button>
      </div>
      <div class=""></div>
    </div>
    <p *ngIf="!activeStatusModel">{{ 'status.no_status_chosen' | translate }}</p>
    <mat-grid-list cols="2" rowHeight="50px">
      <mat-grid-tile *ngFor="let status of interactiveStatusModels$(orgname, login) | async">
        <button
          [id]="'reasonId' + status.reasonId"
          mat-raised-button
          class="statusButton"
          [color]="activeStatusModel && status.reasonId === activeStatusModel.reasonId ? 'primary' : ''"
          [ngClass]="{'color-primary': activeStatusModel && status.reasonId === activeStatusModel.reasonId && !canEdit}"
          (click)="activate(status)"
          [disabled]="!canEdit"
        >
          <img height="24" alt="tick" [src]="status.img" />
          {{ status.message }}
        </button>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
  <div *ngIf="currentState === State.CHANGE_DURATION" fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
    <gt-datetime-input [(datetime)]="currentDateTime"></gt-datetime-input>
    <button id="saveTime" mat-raised-button (click)="changeDuration()" color="primary">{{ 'global.save' | translate }}</button>
    <button mat-raised-button (click)="changeState(State.SELECT_ABSENCE_STATUS)" color="accent">{{ 'global.back' | translate }}</button>
  </div>

  <div *ngIf="currentState === State.CHOOSE_CUSTOM_DURATION" fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
    <gt-datetime-input [(datetime)]="currentDateTime"></gt-datetime-input>
    <button id="saveTime" mat-raised-button (click)="chooseCustomDuration()" color="primary">{{ 'global.save' | translate }}</button>
    <button mat-raised-button (click)="changeState(State.CHOOSE_DURATION)" color="accent">{{ 'global.back' | translate }}</button>
  </div>

  <div *ngIf="currentState === State.CHOOSE_DURATION">
    {{ 'duration.choose_duration' | translate: {status: tempStatusWhileChoosingDuration.message} }}
    <mat-grid-list cols="3" rowHeight="50px">
      <mat-grid-tile *ngFor="let duration of defaultDurations">
        <button mat-raised-button class="settingsButton" (click)="chooseDuration(duration.key)">
          {{ duration.text | translate }}
        </button>
      </mat-grid-tile>
      <mat-grid-tile>
        <button mat-raised-button class="settingsButton" (click)="changeState(State.CHOOSE_CUSTOM_DURATION)">
          {{ 'duration.other_duration' | translate }}
        </button>
      </mat-grid-tile>
      <mat-grid-tile> </mat-grid-tile>
      <mat-grid-tile>
        <button mat-raised-button class="settingsButton" color="primary" (click)="cancelChoosingDuration()">
          {{ 'global.cancel' | translate }}
        </button>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
</div>
<gt-status-settings
  [status]="activeStatusModel"
  [isActiveAbsence]="true"
  [orgname]="orgname"
  [login]="login"
  (backObservable)="changeState(State.SELECT_ABSENCE_STATUS)"
  *ngIf="currentState === State.EDIT_STATUS_SETTINGS"
></gt-status-settings>
